import React, { lazy } from 'react';
import { NonIndexRouteObject, RouteObject } from 'react-router-dom';
import env from '../../env';
import { NavLinkId } from '../../data/types/nav';
import { NavConfig } from '../../data/constants/nav';

const LegacyAppRedirect = lazy(() => import('./LegacyAppRedirect'));

const gateRoutes = (routes: RouteObject[]): RouteObject[] =>
  routes
    .map((route): RouteObject => {
      const navLinkId = route.id as NavLinkId;
      const navConfig = NavConfig.linkConfigs[navLinkId];

      if (navConfig?.toLegacy && !env.reactMigration.migratedLinks[navLinkId]) {
        return {
          ...route,
          element: <LegacyAppRedirect toLegacy={navConfig.toLegacy} />,
        };
      } else {
        return route;
      }
    })
    .map((route): RouteObject => {
      if (route.children) {
        return {
          ...(route as NonIndexRouteObject),
          children: gateRoutes(route.children),
        };
      } else {
        return route;
      }
    });

export default gateRoutes;
